<template>
    <admin-link @click="toTop" class="bg-grey-100 text-dark fixed right-0 bottom-0 md:hidden" v-show="scY > 300">
        <slot></slot>
    </admin-link>
</template>

<script>
import AdminLink from "@/Components/Admin/AdminLink";
export default {
    components: { AdminLink },
    name: "ToTopLink",
    data() {
        return {
            scTimer: 0,
            scY: 0,
        }
    },
    mounted()
    {
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll: function () {
            if (this.scTimer) return;
            this.scTimer = setTimeout(() => {
                this.scY = window.scrollY;
                clearTimeout(this.scTimer);
                this.scTimer = 0;
            }, 100);
        },
        toTop: function ()
        {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
    },
}
</script>

<style scoped>

</style>
